// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const defautlConfig = { skipFileInsertion: false, storeLoadedItems: false };
const logArgs = { eventName: "api.load_assets", inline: true };
const loggerMsgs = { eventStart: ["Preloader", "API", "load_assets"] };

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function load_assets(MANIFEST, CONFIG = defautlConfig) {
  // Setup...
  const loadQueue = this.modules.loadQueue.instance;
  const { skipFileInsertion, storeLoadedItems } = CONFIG;
  this.logger("event", loggerMsgs.eventStart, "event", logArgs);

  // - Set mode to "loading"...
  // - Reset progress...
  // - Set skipFileInsertion & storeLoadedItems option in load queue config. state...
  this.setState({
    mode: "loading",
    loadProgress: 0,
    loadQueueConfig: { skipFileInsertion, storeLoadedItems },
  });

  // Load assets...
  loadQueue.loadManifest(MANIFEST);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
